import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Card, Alert, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'; // Importa useNavigate
import { searchTmdbFilms, importFilmFromTmdb } from '../services/api';
import { useMediaQuery } from 'react-responsive';

function FilmImportTMDB() {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [importing, setImporting] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  
  const isMobile = useMediaQuery({ maxWidth: 991 });
  const navigate = useNavigate(); // Inizializza useNavigate

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSearchResults([]);
    setSuccessMessage(null);

    try {
      const response = await searchTmdbFilms(searchQuery);
      setSearchResults(response.data);
    } catch (err) {
      setError('Errore durante la ricerca su TMDB.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleImportFilm = async (tmdbId) => {
    setImporting(true);
    setError(null);
    setSuccessMessage(null);

    try {
      const response = await importFilmFromTmdb(tmdbId); // Cattura la risposta
      const newFilmId = response.data.id; // Estrai l'ID del film
      setSuccessMessage('Film importato con successo!');
      // Optionally, remove the imported film from the search results
      setSearchResults(prevResults => prevResults.filter(film => film.tmdb_id !== tmdbId));
      navigate(`/film/edit/${newFilmId}`); // Reindirizza alla pagina di modifica
    } catch (err) {
      setError(`Errore durante l'importazione del film: ${err.response?.data?.detail || err.message}`);
      console.error(err);
    } finally {
      setImporting(false);
    }
  };

  return (
    <Container>
      <Row className="mb-4 align-items-center">
        <Col>
          <h1>Importa Film da TMDB</h1>
        </Col>
        <Col xs="auto">
          <Button variant="secondary" onClick={() => navigate('/film')}>
            Torna alla Lista Film
          </Button>
        </Col>
      </Row>
      <Form onSubmit={handleSearch} className="mb-4">
        <Row>
          <Col>
            <Form.Control
              type="text"
              placeholder="Cerca film su TMDB..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Col>
          <Col xs="auto">
            <Button variant="primary" type="submit" disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" /> : 'Cerca'}
            </Button>
          </Col>
        </Row>
      </Form>

      {error && <Alert variant="danger">{error}</Alert>}
      {successMessage && <Alert variant="success">{successMessage}</Alert>}

      <Row>
        {searchResults.map((film) => (
          <Col md={4} className="mb-4" key={film.tmdb_id}>
            <Card>
              {film.immagine_url && (
                <Card.Img variant="top" src={`${process.env.REACT_APP_API_BASE_URL}${film.immagine_url}`} alt={film.titolo} style={{ height: '300px', objectFit: 'cover' }} />
              )}
              <Card.Body>
                <Card.Title>{film.titolo} ({film.anno})</Card.Title>
                <Card.Text>{film.overview ? `${film.overview.substring(0, 150)}...` : 'Nessuna descrizione disponibile.'}</Card.Text>
                <Button 
                  variant="success" 
                  onClick={() => handleImportFilm(film.tmdb_id)} 
                  disabled={importing}
                >
                  {importing ? <Spinner animation="border" size="sm" /> : 'Importa'}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default FilmImportTMDB;
